/**
 * The corner a checkbox is cut with, in px.
 *
 * Its own token rather than `theme.shape.borderRadius`, which is MUI's default 4 and is what the
 * surfaces around a checkbox -- cards, menus, inputs -- are cut with. A tick is 18px square and
 * reads squarer than those at the same radius, so the control carries 6 and has since the theme
 * was written.
 *
 * Declared once because it is drawn in five places: the root `MuiCheckbox` override, and each of
 * the four glyphs, which cannot inherit it -- the radius belongs to the `<svg>` box itself, and
 * `styleOverrides` on the root reaches the button rather than the icon inside it.
 */
export const CHECKBOX_RADIUS = 6;

/** The same, for the `sx` prop, whose `borderRadius` multiplies a bare number by `shape`. */
export const CHECKBOX_RADIUS_PX = `${CHECKBOX_RADIUS}px`;

/**
 * Croissant corner radii, in px. Use these rather than arbitrary values so surfaces stay consistent.
 *
 * Ready for `styled()`, where a bare number is pixels. In `sx`, which multiplies a bare `borderRadius`
 * by `shape`, pass `` `${CROISSANT_RADIUS.lg}px` `` instead.
 *
 * @link https://www.figma.com/design/anJykRaoHi8nXjqpqlynmd/Croissant-%7C-Design-System?node-id=8952-23418
 */
export const CROISSANT_RADIUS = {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    full: 1000,
} as const;
